import dayjs from 'dayjs';

var getCookie = function getCookie(name) {
  var value = "; " + document.cookie;

  var _value$split = value.split("; " + name + "="),
      cookie = _value$split[1];

  if (cookie) return cookie.split(';')[0];
  return '';
};
var setCookie = function setCookie(name, value, expireDays) {
  if (expireDays === void 0) {
    expireDays = 5000;
  }

  var date = new Date();
  date.setTime(date.getTime() + expireDays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + date.toUTCString();
  document.cookie = name + "=" + value + "; " + expires + "; path=/;";
};
var deleteCookie = function deleteCookie(name) {
  document.cookie = name + "=; path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
};

var formatAMPM = function formatAMPM(hour) {
  var globalTime = dayjs().format('YYYY-MM-DD');
  return dayjs(globalTime + hour).format('hh:mm a');
};

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var getEnvs = function getEnvs(envs, keyStarWiths) {
  return Object.entries(envs).reduce(function (result, _ref) {
    var key = _ref[0],
        value = _ref[1];

    if (keyStarWiths.some(function (keyStarWith) {
      return key.startsWith(keyStarWith);
    })) {
      var _extends2;

      return _extends({}, result, (_extends2 = {}, _extends2[key] = JSON.stringify(value), _extends2));
    }

    return result;
  }, {});
};

var regex = /[^\dkK]/g;

var validateChileanRut = function validateChileanRut(rut) {
  var unFormattedRut = rut.replace(regex, '');
  var body = unFormattedRut.slice(0, -1);

  if (body.length < 7 || body.length > 9) {
    return false;
  }

  var verifierDigit = unFormattedRut.slice(-1).toUpperCase();
  var sum = 0;
  var mul = 2;

  for (var i = 1; i <= body.length; i += 1) {
    var index = mul * parseInt(unFormattedRut.charAt(body.length - i), 10);
    sum += index;

    if (mul < 7) {
      mul += 1;
    } else {
      mul = 2;
    }
  }

  var expectedVerifierDigit = 11 - sum % 11;
  verifierDigit = verifierDigit === 'K' ? '10' : verifierDigit;
  verifierDigit = parseInt(verifierDigit, 10) === 0 ? '11' : verifierDigit;
  return expectedVerifierDigit === parseInt(verifierDigit, 10);
};

export { deleteCookie, formatAMPM, getCookie, getEnvs as getEnvValues, setCookie, validateChileanRut };
//# sourceMappingURL=sapphire.esm.js.map
